module.exports = __webpack_public_path__ + "static/media/edit.aaccd2d0.svg";